import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Sitemap from './views/Sitemap.vue';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/sitemap',
      name: 'sitemap',
      component: Sitemap,
    },
    {
      path: '/art/:artLink',
      name: 'home-art',
      component: Home,
    },
    {
      path: '/story/:storyLink',
      name: 'home-story',
      component: Home,
    },
    {
      path: '/art/:artLink/story/:storyLink',
      name: 'home-art-and-story',
      component: Home,
    },
    {
      path: '/category/:categoryName',
      name: 'home-category',
      component: Home,
    },
    {
      path: '/year/:year',
      name: 'home-year',
      component: Home,
    },
    {
      path: '/admin/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/admin/forgot-password',
      name: 'forgot-password',
      component: () => import(/* webpackChunkName: "forgot-password" */ './views/ForgotPassword.vue'),
    },
    {
      path: '/admin/reset-password',
      name: 'reset-password',
      component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
    },
    {
      path: '/admin/stories',
      name: 'stories',
      component: () => import(/* webpackChunkName: "stories" */ './views/Stories.vue'),
    },
    {
      path: '/admin/art',
      name: 'art',
      component: () => import(/* webpackChunkName: "art" */ './views/Art.vue'),
    },
    {
      path: '/admin/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
    },
    {
      path: '/admin/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
    },
    { path: '/admin', redirect: '/admin/stories' },
    { path: '/login', redirect: '/admin/login' },
  ],
});

router.afterEach((to, from) => {
  window.document.title = 'ArtStory';
  if (to.path.includes('admin')) {
    window.document.title = 'ArtStory-CMS Admin';
  }
});

export default router;